import React, { useState, useEffect, useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { AuthContext } from '../../../Header/auth - context';
import { translateCol } from '../../../custom/columnI18n';
import './AlarmiHome.css';

const AlarmiHome = () => {
    const { t } = useTranslation();
    const auth = useContext(AuthContext);
    const toast = useRef(null);

    const [tab, setTab] = useState('VOZILA'); // 'VOZILA' | 'VOZAC' | 'FAKTURE'
    const [tipovi, setTipovi] = useState([]);   // [{id_tip, grupa, naziv, aktivan}]
    const [aktivni, setAktivni] = useState({}); // { id_tip: bool }
    const [saving, setSaving] = useState(false);
    const activeClass = 'activeButton';

    const authHeaders = () => ({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token });

    const load = (kategorija) => {
        fetch(process.env.REACT_APP_BACKEND_URL + '/config/alarmi/get', {
            method: 'POST', headers: authHeaders(), body: JSON.stringify({ kategorija }),
        })
            .then(r => r.ok ? r.json() : Promise.reject(r))
            .then(rows => {
                const list = Array.isArray(rows) ? rows : [];
                setTipovi(list);
                const map = {};
                list.forEach(r => { map[r.id_tip] = Number(r.aktivan) === 1; });
                setAktivni(map);
            })
            .catch(() => { setTipovi([]); setAktivni({}); });
    };

    useEffect(() => {
        if (tab === 'VOZILA' || tab === 'VOZAC') load(tab);
        else { setTipovi([]); setAktivni({}); }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tab]);

    const toggle = (id) => setAktivni(prev => ({ ...prev, [id]: !prev[id] }));
    const setAll = (val) => {
        const map = {};
        tipovi.forEach(r => { map[r.id_tip] = val; });
        setAktivni(map);
    };

    const save = () => {
        setSaving(true);
        const stavke = tipovi.map(r => ({ id_tip: r.id_tip, aktivan: aktivni[r.id_tip] ? 1 : 0 }));
        fetch(process.env.REACT_APP_BACKEND_URL + '/config/alarmi/save', {
            method: 'POST', headers: authHeaders(), body: JSON.stringify({ kategorija: tab, stavke }),
        })
            .then(r => r.ok ? r.json() : Promise.reject(r))
            .then(() => toast.current?.show({ severity: 'success', summary: t('alarmi.sacuvano'), life: 2500 }))
            .catch(() => toast.current?.show({ severity: 'error', summary: t('admin.m_greska'), life: 3000 }))
            .finally(() => setSaving(false));
    };

    // grupisanje po grupi (čuva redosled iz SP-a)
    const groups = [];
    tipovi.forEach(r => {
        let g = groups.find(x => x.grupa === r.grupa);
        if (!g) { g = { grupa: r.grupa, items: [] }; groups.push(g); }
        g.items.push(r);
    });

    const isConfigTab = tab === 'VOZILA' || tab === 'VOZAC';

    return (
        <div className="alarmi-wrap">
            <Toast ref={toast} />

            {/* Sub-tabovi */}
            <div className="alarmi-subtabs" style={{ marginBottom: '10px' }}>
                <Button id={tab === 'VOZILA' ? activeClass : undefined} label={t('alarmi.vozila')} className="mt-3 zaposleniShift adminTab" onClick={() => setTab('VOZILA')} />
                <Button id={tab === 'VOZAC' ? activeClass : undefined} label={t('alarmi.vozaci')} className="mt-3 zaposleniShift adminTab" onClick={() => setTab('VOZAC')} />
                <Button id={tab === 'FAKTURE' ? activeClass : undefined} label={t('alarmi.fakture')} className="mt-3 zaposleniShift adminTab" onClick={() => setTab('FAKTURE')} />
            </div>

            {isConfigTab && (
                <>
                    <div className="alarmi-header">
                        <p className="alarmi-title">{tab === 'VOZILA' ? t('alarmi.naslovVozila') : t('alarmi.naslovVozaci')}</p>
                        <div className="alarmi-toolbar">
                            <Button label={t('alarmi.ukljuciSve')} icon="pi pi-check" className="p-button-sm p-button-outlined" onClick={() => setAll(true)} />
                            <Button label={t('alarmi.iskljuciSve')} icon="pi pi-times" className="p-button-sm p-button-outlined p-button-secondary" onClick={() => setAll(false)} />
                            <Button label={t('common.sacuvaj')} icon="pi pi-save" className="p-button-sm p-button-success" onClick={save} loading={saving} />
                        </div>
                    </div>
                    <p className="alarmi-desc">{t('alarmi.opis')}</p>

                    <div className="alarmi-list">
                        {groups.map(g => (
                            <div key={g.grupa} className="alarmi-group">
                                <div className="alarmi-group-title">{translateCol(t, g.grupa)}</div>
                                {g.items.map(item => (
                                    <div key={item.id_tip} className="alarmi-row">
                                        <span className="alarmi-row-name">{translateCol(t, item.naziv)}</span>
                                        <button type="button" role="switch" aria-checked={!!aktivni[item.id_tip]}
                                            className={`alarm-toggle${aktivni[item.id_tip] ? ' on' : ''}`}
                                            onClick={() => toggle(item.id_tip)} title={aktivni[item.id_tip] ? t('alarmi.ukljucen') : t('alarmi.iskljucen')}>
                                            <span className="alarm-toggle-knob" />
                                        </button>
                                    </div>
                                ))}
                            </div>
                        ))}
                        {groups.length === 0 && <p className="alarmi-desc">{t('alarmi.nemaTipova')}</p>}
                    </div>
                </>
            )}

            {tab === 'FAKTURE' && (
                <div style={{ marginTop: '1rem' }}>
                    <p className="alarmi-title">{t('alarmi.fakture')}</p>
                    {/* SEF podešavanja su preseljena u Administracija → Firma → SEF
                        (16.09.2026): API ključ je tajna i vide ga samo direktor i
                        eskaliran, a ovaj ekran je otvoren svima sa pravom na
                        Administraciju. */}
                    <p className="alarmi-desc">{t('alarmi.faktureUPripremi')}</p>
                </div>
            )}
        </div>
    );
};

export default AlarmiHome;
